import { render } from "./CancerView.vue?vue&type=template&id=08d014f3"
import script from "./CancerView.vue?vue&type=script&lang=js"
export * from "./CancerView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__